import type { SVGProps } from "react";
export interface AuditIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function AuditIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: AuditIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M16.875 7.073V5c0-1.035-.84-1.875-1.874-1.875H5c-1.036 0-1.875.84-1.875 1.875v14c0 1.035.84 1.875 1.875 1.875h3l.114.005a1.126 1.126 0 0 1 0 2.239L8 23.125H5A4.125 4.125 0 0 1 .875 19V5A4.125 4.125 0 0 1 5 .875h10A4.125 4.125 0 0 1 19.126 5v2.073a1.126 1.126 0 0 1-2.25 0Z"
      />
      <path
        fill={color}
        d="M18.375 13.5a1.376 1.376 0 0 0-2.75 0c0 .378.116.772.314 1.34.18.512.447 1.217.523 1.974l.056.561h.965l.056-.561c.075-.757.343-1.462.522-1.975.199-.567.314-.962.314-1.338Zm-4.326 6.585c-.628.18-.76.316-.794.362-.024.033-.08.128-.11.428h7.71c-.03-.3-.087-.395-.111-.428-.026-.034-.107-.12-.409-.236l-.385-.126-1.606-.46h-2.69zm-3.378-9.21.116.006a1.125 1.125 0 0 1 0 2.239l-.116.006H6a1.125 1.125 0 0 1 0-2.25h4.671Zm2.876-4a1.125 1.125 0 0 1 0 2.25H6a1.125 1.125 0 0 1 0-2.25zm7.078 6.626c0 .803-.246 1.528-.44 2.081-.212.608-.365 1.026-.408 1.456l-.065.639.856.244.277.084c.642.208 1.262.514 1.695 1.087.494.655.585 1.452.585 2.219V22c0 .62-.503 1.124-1.125 1.125H12A1.125 1.125 0 0 1 10.875 22v-.689c0-.767.09-1.564.585-2.22.494-.655 1.234-.959 1.971-1.17l.856-.244-.063-.639c-.043-.43-.197-.848-.41-1.456-.192-.553-.438-1.278-.438-2.082a3.625 3.625 0 1 1 7.249 0Z"
      />
    </svg>
  );
}
